<template>
	<div>
		<div v-for="item in image_items">
			<span v-if="isEmpty">沒有圖片</span>
			<img v-else width="auto" :src="get_image(item)"/>
		</div>
	</div>
</template>

<script>
import { config } from '@/config.js';
import { abstractField } from '@backstagex-vue-form-generator/core';
export default {
	mixins: [abstractField],
	props: ['schema', 'model'],
	// data() {
	// 	return {
	// 		data: 'data:image/gif;base64,' + this.model[this.schema.model],
	// 		image_items:[],
	// 	};
	// },
	created() {
		this.image_items = this.model[this.schema.model].split(",");
	},
	methods: {
		get_image: function (item) {
			if(item.indexOf("opinion/") != -1){
				return config.storageHost  + item;
			}else{
				return 'data:image/gif;base64,' + item;
			}			
		},
	},
	computed: {		
		isEmpty: function () {
			return (
				this.model[this.schema.model] === '' ||
				this.model[this.schema.model] === null ||
				this.model[this.schema.model] === undefined
			);
		},
	},
};
</script>
